

















































































import { Component, Vue, Prop } from 'vue-property-decorator';

import {
  ResponseCodeEnum,
  DataTableRequest,
  TireStoringContract,
  EnumObject,
  TireContractDate,
} from '@/models';

import { tireStoringContractService, toastService } from '@/services';

import { DataTableSetting, FieldEnum, ActionEnum } from '@/components/shared';
import DataTable from '@/components/shared/table/DataTable.vue';
import QrcodeReader from '@/components/shared/qrcode/QrcodeReader.vue';
import _ from 'lodash';

@Component({
  components: {
    DataTable,
    QrcodeReader,
  },
})
export default class SearchContractAndRequestDelivery extends Vue {
  @Prop() public date!: string;
  private status: number = 0;
  private contractDate: string = '';
  private showQrcodeReader: boolean = false;
  private searchText: string = '';
  private options: EnumObject[] = [];
  private searchByQrCode: boolean = false;
  private showModal: boolean = false;
  private message: string = '';
  private showDeliveryModal: boolean = false;
  private showDate: string = ''

  private tableFields = [
    {
      key: 'slipNo',
      label: 'view.search_tire_contract.label.contract_number',
      type: FieldEnum.FIELD_TEXT,
      sortable: false,
    },
    {
      key: 'customer.name',
      label: 'view.search_tire_contract.label.fullname',
      type: FieldEnum.FIELD_TEXT,
      sortable: false,
    },
    {
      key: 'contractEndDate',
      label: 'view.search_tire_contract.label.storing_date',
      type: FieldEnum.FIELD_DATE_DAYLEFT_TEXT,
      sortable: false,
    },
  ];
  private getItems: Function = new Function();
  private tableSetting: DataTableSetting = new DataTableSetting();

  private created() {
    this.$moment.tz.setDefault('UTC');
    this.contractDate = this.$moment(this.date).format('YYYY年MMMDo')+ " ("+ this.getDayOfWeek(new Date(this.date).getDay()) + ")";
    this.getItems = ((request: DataTableRequest) => {
      return tireStoringContractService
        .getByContractEndDate(this.searchByQrCode, request)
        .then((res) => {
          if (res.data.items && res.data.totalRows) {
            this.tableSetting.totalRows = res.data.totalRows;
            return res.data.items || [];
          }
        });
    });
    this.tableSetting = DataTableSetting.init(
      'storingDate',
      'desc',
      this.tableFields,
      this.getItems,
      false,
      true,
    );
  }

  private onDecode(result: string) {
    this.showQrcodeReader = false;
    if (result) {
      this.searchText = result;
      this.searchByQrCode = true;
      this.tableSetting.filter = result;
    }
  }

  private search() {
    this.tableSetting.filter = this.searchText;
  }

  private onChangeSearchText() {
    this.searchByQrCode = false;
  }

  private showModalDelivery() {
      const deliveryDate = this.$moment(this.date).format('MM/DD(dd)');
      this.showDate = `${this.$t('dialog.dateSelect').toString()} ${deliveryDate.toString()}`
      this.showDeliveryModal = true;
  }

  private deliveryRequest() {
    const items = this.tableSetting.selected;
    const tireContractDate = new TireContractDate({lstContractIds: items, date: this.$moment(this.date).toDate()});
    tireStoringContractService.deliveryContract(tireContractDate)
    .then((res) => {
      if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
        (this.$refs.dataTable as any).refreshTable();
      }
      if(res.data.code === ResponseCodeEnum.CODE_BAD_REQUEST) {
        this.message = res.data.data.map((a: any) => 
          this.$t('view.tire_register.message.delivery_exceeded').toString().replace('{agency_name}', a.name).replace('{limit}', a.limitDeliveryValue ? a.limitDeliveryValue: 0) + '</br>'
        )       
        .join('');
      } else {
        this.message =  this.$t(res.data.data.toString()).toString();
      }
      this.showModal = true;
    });
  }

  private scanBarCode() {
    this.showQrcodeReader = true;
  }

  private getDayOfWeek(value: number) {
    switch (value) {
      case 0: return this.$t("common.day_of_week.sunday").toString();
      case 1: return this.$t("common.day_of_week.monday").toString();
      case 2: return this.$t("common.day_of_week.tuesday").toString();
      case 3: return this.$t("common.day_of_week.wednesday").toString();
      case 4: return this.$t("common.day_of_week.thursday").toString();
      case 5: return this.$t("common.day_of_week.friday").toString();
      case 6: return this.$t("common.day_of_week.saturday").toString();
    }
  }

}
